export const ADD_LOCATION_PARAM = "addLocation";

// The URL vocabulary is deliberately separate from the modal's internal step
// names, so the address bar never shows "main" and the internal names stay
// free to change.
const STEP_BY_VALUE = {
  type: "main",
  mobile: "mobile",
  base: "base",
};

const VALUE_BY_STEP = {
  main: "type",
  mobile: "mobile",
  base: "base",
};

// Returns null for a missing or unrecognised value, so a hand-edited URL like
// ?addLocation=bogus reads as "closed" rather than rendering a broken step.
export const addLocationStepFrom = search =>
  STEP_BY_VALUE[new URLSearchParams(search).get(ADD_LOCATION_PARAM)] || null;

// Merges into the existing query string -- the warehouse view keeps its
// filters, sort and page there (see useWarehouseFilters).
export const addLocationSearch = (search, step) => {
  const params = new URLSearchParams(search);

  if (step && VALUE_BY_STEP[step]) {
    params.set(ADD_LOCATION_PARAM, VALUE_BY_STEP[step]);
  } else {
    params.delete(ADD_LOCATION_PARAM);
  }

  return params.toString();
};
